import cloneDeep from 'lodash/cloneDeep';
import {
  Component, Input, Output, OnInit,
  OnChanges, ViewChild, ElementRef, SimpleChanges,
  EventEmitter, ViewEncapsulation, HostListener
} from '@angular/core';
import { CustomComponent } from '@cakeiteasy/web-utils';
import { SearchCakesService } from '../../services/search-cakes.service';
import { IFilterModel } from '../../models/i-filter.model';

@Component({
  standalone: false,
  selector: 'filter-tags',
  templateUrl: './filter-tags.component.html',
  styleUrls: ['./filter-tags.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class FilterTagsComponent extends CustomComponent implements OnInit, OnChanges {
  @Input() public filters: IFilterModel;
  @Input() public isStick: boolean;
  @Input() public calculateHeight: any;
  @Output() public onPanelHeightEmit = new EventEmitter<any>();

  public model: IFilterModel;

  @ViewChild('panel', { static: false }) public panel: ElementRef;

  @HostListener('window:resize', [])
  handleResize() {
    this._heightEmit();
  }

  constructor(public searchCakes: SearchCakesService) {
    super();

    this._subscribe();
  }

  ngOnInit() {
    this.model = cloneDeep(this.filters);
  }

  ngOnChanges(changes: SimpleChanges): void {
    this._heightEmit();
  }

  public resetFilters() {
    this.model = this.searchCakes.resetFilters(this.model);
  }

  public onModelChange() {
    this.searchCakes.criteriaChanged$.next(this.model);
  }

  /**
   * When filter-tags-panel become fixed position, it is disappear from normal html flow, and height general window reduces,
   * so it is necessary to compensate filter-tags-panel height while it is stay fixed position
   * */
  private _heightEmit() {
    setTimeout(() => {
      const offsetHeight = this.panel ? this.panel.nativeElement.offsetHeight : 0;
      this.onPanelHeightEmit.emit(offsetHeight);
    });
  }

  private _subscribe() {
    this.addSubscriber(this.searchCakes.criteriaChanged$.subscribe((model) => {
      this.model = cloneDeep(model);
      this._heightEmit();
    }));
  }
}
